import { FC } from 'react';
import InCalculation, { InCalculationProps } from './InCalculation';
import { AllocationCalcStatus } from '../../../types/carAllocation';
import Aborted, { AbortedProps } from './Aborted';
import Succeeded, { SucceededProps } from './Succeeded';
import OthersCalculating from './OthersCalculating';
import { ToastPopUp } from '../ToastPopUp';
import { useGetCurrentUserQuery } from '../../../api/userApi';

type Props = {
  status: AllocationCalcStatus | null;
  isSelfExecuted: boolean;
} & InCalculationProps &
  AbortedProps &
  SucceededProps;

const AllocationStatusIndicator: FC<Props> = ({
  status,
  isSelfExecuted,
  onCancel,
  onAbortedCancel,
  onAbortedUpdate,
  onClose,
}) => {
  const { data: user } = useGetCurrentUserQuery();
  if (!user) {
    return null;
  }
  if (!isSelfExecuted) {
    if (status === 'started' || status === 'failed') {
      return (
        <ToastPopUp>
          <OthersCalculating />
        </ToastPopUp>
      );
    }
    onClose();
    return null;
  }
  switch (status) {
    case 'started':
      return (
        <ToastPopUp>
          <InCalculation onCancel={onCancel} />
        </ToastPopUp>
      );
    case 'failed':
      return (
        <ToastPopUp>
          <Aborted
            onAbortedCancel={onAbortedCancel}
            onAbortedUpdate={onAbortedUpdate}
          />
        </ToastPopUp>
      );
    case 'aborted':
      return (
        <ToastPopUp>
          <Aborted />
        </ToastPopUp>
      );
    case 'succeeded':
      return (
        <ToastPopUp>
          <Succeeded onClose={onClose} onConfirm={onAbortedUpdate} />
        </ToastPopUp>
      );
    default:
      return null;
  }
};

export default AllocationStatusIndicator;
